export const categories = [
  {
    slug: "remen",
    name: "热门推荐",
    icon: "ri-fire-line",
    description: "全网最热视频内容，每日更新精选推荐",
  },
  {
    slug: "dianying",
    name: "电影",
    icon: "ri-film-line",
    description: "国内外高清正版电影，新片热片一网打尽",
  },
  {
    slug: "dianshiju",
    name: "电视剧",
    icon: "ri-tv-line",
    description: "热门电视剧全集在线观看，追剧不等待",
  },
  {
    slug: "zongyi",
    name: "综艺",
    icon: "ri-emotion-laugh-line",
    description: "热门综艺节目，欢笑不断精彩不停",
  },
  {
    slug: "dongman",
    name: "动漫",
    icon: "ri-ghost-line",
    description: "热血动漫全网更新最快，二次元爱好者必备",
  },
  {
    slug: "jilupian",
    name: "纪录片",
    icon: "ri-earth-line",
    description: "精品纪录片，探索世界发现未知",
  },
  {
    slug: "shaoer",
    name: "少儿",
    icon: "ri-rocket-line",
    description: "优质少儿内容，陪伴孩子健康成长",
  },
];

export const videos = [
  {
    id: 1,
    title: "星际穿越：穿越时空的壮丽旅程",
    category: "dianying",
    cover: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20scene%20with%20astronaut%20floating%20near%20a%20massive%20black%20hole%2C%20dramatic%20cosmic%20lighting%2C%20cinematic%20atmosphere%2C%20deep%20space%20background%20with%20stars%20and%20nebula%2C%20warm%20orange%20and%20gold%20accents%2C%20movie%20poster%20style%2C%20clean%20composition&width=800&height=450&seq=video-cover-01&orientation=landscape",
    duration: "2:49:12",
    views: 12890000,
    rating: 9.4,
    description: "一队探险家利用虫洞进行超越人类极限的星际旅行，在浩瀚宇宙中寻找人类未来的希望。",
    featured: true,
    tags: ["科幻", "冒险", "经典"],
  },
  {
    id: 2,
    title: "舌尖上的中国：寻味之旅",
    category: "jilupian",
    cover: "https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20cuisine%20documentary%20scene%2C%20steaming%20hot%20traditional%20dishes%20on%20wooden%20table%2C%20warm%20ambient%20kitchen%20lighting%2C%20rich%20colors%20of%20fresh%20ingredients%2C%20artistic%20food%20photography%20style%2C%20clean%20cream%20background%2C%20elegant%20composition&width=800&height=450&seq=video-cover-02&orientation=landscape",
    duration: "45:30",
    views: 8950000,
    rating: 9.6,
    description: "穿越中国广袤大地，探寻各地特色美食背后的文化与故事。",
    featured: true,
    tags: ["美食", "文化", "纪录"],
  },
  {
    id: 3,
    title: "长安十二时辰",
    category: "dianshiju",
    cover: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20cityscape%20at%20sunset%2C%20traditional%20architecture%20with%20red%20lanterns%2C%20dramatic%20warm%20golden%20hour%20lighting%2C%20historical%20drama%20atmosphere%2C%20cinematic%20composition%2C%20clean%20and%20elegant%20style&width=800&height=450&seq=video-cover-03&orientation=landscape",
    duration: "48集",
    views: 23500000,
    rating: 9.3,
    description: "大唐天宝三年，上元节前夕，长安城陷入危机，死囚张小敬临危受命拯救长安。",
    featured: true,
    tags: ["古装", "悬疑", "历史"],
  },
  {
    id: 4,
    title: "海底总动员：深蓝奇遇",
    category: "dongman",
    cover: "https://readdy.ai/api/search-image?query=Vibrant%20underwater%20animation%20scene%20with%20colorful%20tropical%20fish%20swimming%20through%20coral%20reef%2C%20crystal%20clear%20blue%20water%2C%20sunlight%20streaming%20from%20surface%2C%20cheerful%20and%20warm%20atmosphere%2C%20animated%20movie%20style%2C%20clean%20composition&width=800&height=450&seq=video-cover-04&orientation=landscape",
    duration: "1:40:28",
    views: 6720000,
    rating: 9.1,
    description: "小丑鱼父子在辽阔海洋中的冒险旅程，关于勇气、友谊与家庭的温暖故事。",
    featured: false,
    tags: ["动画", "冒险", "温情"],
  },
  {
    id: 5,
    title: "奔跑吧！欢乐季第五期",
    category: "zongyi",
    cover: "https://readdy.ai/api/search-image?query=Outdoor%20variety%20show%20scene%20with%20group%20of%20people%20running%20and%20laughing%20in%20a%20colorful%20obstacle%20course%2C%20bright%20sunny%20day%2C%20energetic%20and%20joyful%20atmosphere%2C%20entertainment%20show%20style%2C%20clean%20composition&width=800&height=450&seq=video-cover-05&orientation=landscape",
    duration: "1:32:15",
    views: 15600000,
    rating: 8.9,
    description: "本期节目来到美丽的海滨城市，嘉宾们展开一场充满欢笑的趣味竞技挑战。",
    featured: true,
    tags: ["娱乐", "竞技", "搞笑"],
  },
  {
    id: 6,
    title: "英雄联盟：双城之战",
    category: "dongman",
    cover: "https://readdy.ai/api/search-image?query=Steampunk%20animation%20cityscape%20with%20towering%20clockwork%20buildings%20under%20dramatic%20orange%20sky%2C%20two%20contrasting%20cities%20divided%20by%20a%20bridge%2C%20cinematic%20animation%20style%2C%20clean%20dark%20composition&width=800&height=450&seq=video-cover-06&orientation=landscape",
    duration: "9集",
    views: 18900000,
    rating: 9.5,
    description: "在蒸汽朋克风格的双城中，姐妹情深与命运抉择的史诗故事。",
    featured: false,
    tags: ["动画", "奇幻", "动作"],
  },
  {
    id: 7,
    title: "蓝色星球：深海探秘",
    category: "jilupian",
    cover: "https://readdy.ai/api/search-image?query=Deep%20ocean%20documentary%20scene%20with%20bioluminescent%20jellyfish%20and%20mysterious%20sea%20creatures%20in%20dark%20blue%20water%2C%20ethereal%20underwater%20lighting%2C%20nature%20documentary%20cinematography%2C%20clean%20composition&width=800&height=450&seq=video-cover-07&orientation=landscape",
    duration: "52:18",
    views: 7230000,
    rating: 9.7,
    description: "潜入深海世界，探索人类从未见过的神秘生物与壮丽景观。",
    featured: false,
    tags: ["自然", "海洋", "探索"],
  },
  {
    id: 8,
    title: "流浪地球2：人类勇气赞歌",
    category: "dianying",
    cover: "https://readdy.ai/api/search-image?query=Massive%20futuristic%20space%20elevator%20rising%20from%20earth%20surface%20toward%20space%20station%2C%20dramatic%20cinematic%20lighting%20with%20orange%20and%20teal%20contrast%2C%20epic%20sci-fi%20movie%20scene%2C%20clean%20composition&width=800&height=450&seq=video-cover-08&orientation=landscape",
    duration: "2:53:08",
    views: 31200000,
    rating: 9.2,
    description: "人类面临太阳危机，联合政府展开宏大救援计划，展现人类面对末日的勇气与智慧。",
    featured: true,
    tags: ["科幻", "灾难", "国产"],
  },
  {
    id: 9,
    title: "小小智慧树：动物王国",
    category: "shaoer",
    cover: "https://readdy.ai/api/search-image?query=Colorful%20children%20education%20scene%20with%20cute%20cartoon%20animals%20in%20a%20bright%20sunny%20forest%2C%20cheerful%20and%20playful%20atmosphere%2C%20educational%20kids%20content%20style%2C%20clean%20composition%20with%20warm%20colors&width=800&height=450&seq=video-cover-09&orientation=landscape",
    duration: "25:40",
    views: 4520000,
    rating: 9.0,
    description: "带领小朋友们认识各种可爱动物，寓教于乐的早教内容。",
    featured: false,
    tags: ["教育", "动物", "启蒙"],
  },
  {
    id: 10,
    title: "庆余年：权谋天下",
    category: "dianshiju",
    cover: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20interior%20with%20intricate%20wooden%20carvings%20and%20silk%20drapes%2C%20warm%20candlelight%20atmosphere%2C%20historical%20drama%20setting%2C%20elegant%20and%20mysterious%20composition%2C%20clean%20cinematic%20style&width=800&height=450&seq=video-cover-10&orientation=landscape",
    duration: "46集",
    views: 28700000,
    rating: 9.4,
    description: "身世神秘的少年范闲，在复杂的权谋斗争中一步步走向自己的人生巅峰。",
    featured: true,
    tags: ["古装", "权谋", "剧情"],
  },
  {
    id: 11,
    title: "相声有新人：爆笑专场",
    category: "zongyi",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20traditional%20comedy%20stage%20performance%20with%20two%20performers%20in%20traditional%20robes%2C%20warm%20stage%20lighting%2C%20red%20and%20gold%20decor%2C%20joyful%20and%20entertaining%20atmosphere%2C%20clean%20composition&width=800&height=450&seq=video-cover-11&orientation=landscape",
    duration: "1:15:30",
    views: 9340000,
    rating: 8.8,
    description: "新生代相声演员齐聚舞台，带来精彩绝伦的相声表演。",
    featured: false,
    tags: ["喜剧", "相声", "传统"],
  },
  {
    id: 12,
    title: "小猪佩奇：快乐的一天",
    category: "shaoer",
    cover: "https://readdy.ai/api/search-image?query=Cute%20cartoon%20pig%20family%20playing%20in%20a%20sunny%20green%20meadow%20with%20colorful%20flowers%2C%20cheerful%20children%20animation%20style%2C%20bright%20and%20warm%20colors%2C%20simple%20clean%20composition&width=800&height=450&seq=video-cover-12&orientation=landscape",
    duration: "5:15",
    views: 3210000,
    rating: 8.7,
    description: "佩奇和乔治一起度过充满欢乐的一天，学习分享与友爱。",
    featured: false,
    tags: ["动画", "启蒙", "亲子"],
  },
];